// src/components/wizard/WizardProvince.jsx
import React from 'react';
import styles from './WizardStep.module.css';

const PROVINCES = ['BC','AB','SK','MB','ON','QC','NB','NS','PE','NL','YT','NT','NU'];

export default function WizardProvince({ selected, onSelect, canContinue, onBack, onNext, onSkip }) {
  return (
    <div className={styles.stepWrap}>
      <p className={styles.eyebrow}>Where you are</p>
      <h1 className={styles.title}>Which province or<br />territory are you <em>in?</em></h1>
      <p className={styles.subSm}>We'll prioritise programs in your region, plus all national programs.</p>

      <div className={styles.provGrid} style={{ maxWidth: 460 }}>
        {PROVINCES.map(p => (
          <button
            key={p}
            className={`${styles.provBtn} ${selected === p ? styles.selected : ''}`}
            onClick={() => onSelect(p)}
          >
            {p === 'PE' ? 'PEI' : p}
          </button>
        ))}
        <button
          className={`${styles.provBtn} ${selected === 'all' ? styles.selected : ''}`}
          onClick={() => onSelect('all')}
        >
          Not sure
        </button>
      </div>

      <div className={styles.btnRow}>
        <button className={styles.btnBack} onClick={onBack}>← Back</button>
        <button className={styles.btnNext} onClick={onNext} disabled={!canContinue}>Continue →</button>
        <button className={styles.btnText} onClick={onSkip}>Skip all</button>
      </div>
    </div>
  );
}
